export const AUTH_HEADERS = {
    X_PETM_ANONYMOUS_KEY: 'x-petm-anonymous-key',
    X_PETM_CUSTOMER_KEY: 'x-petm-customer-key',
    X_PETM_SKIP_RECAPTCHA: 'x-petm-account-skip-recaptcha',
    X_PETM_LOYALTY_NUMBER: 'x-petm-customer-loyalty-number',
    X_VERCEL_PROECTION_BYPASS: 'x-vercel-protection-bypass',
    AUTHORIZATION: 'Authorization',
    CONTENT_TYPE: 'Content-Type',
};

/**
 * Query parameters to exclude from the cache key.
 * These parameters typically do not affect the page results and are often used by tracking or third-party services.
 */
export const EXCLUDED_PARAMS = [
    'utm_source',
    'utm_content',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_id',
    'mi_u',
    'mi_ecmp',
    'sfmc_id',
    'rid',
    'gclsrc',
    'gad_source',
    'gbraid',
    'gclsrc',
] as [string, ...string[]];
